import { render, staticRenderFns } from "./GrayBarReelsNumber.vue?vue&type=template&id=0cc85050&"
import script from "./GrayBarReelsNumber.vue?vue&type=script&lang=js&"
export * from "./GrayBarReelsNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports